export default "__VITE_ASSET__Bk3rXmu2__"